import { useListViewStore, type ListDensity, type ListView } from '../store/list-view.store';

/** One list's view + density with setters, falling back to `defaults` until the user picks. */
export function useListView(
  listKey: string,
  defaults: { view?: ListView; density?: ListDensity } = {},
) {
  const saved = useListViewStore((s) => s.prefs[listKey]);
  const setPrefs = useListViewStore((s) => s.setPrefs);
  return {
    view: saved?.view ?? defaults.view ?? 'list',
    density: saved?.density ?? defaults.density ?? 'normal',
    setView: (view: ListView) => {
      setPrefs(listKey, { view });
    },
    setDensity: (density: ListDensity) => {
      setPrefs(listKey, { density });
    },
  };
}
